<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button class="btnback btn btn-outline-success" type="button" (click)="onBack()" title="Volver"><i class="fa fa-chevron-left"></i></button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" type="button" class="btn btn-outline-success" (click)="guardarLugarProduccion()" title="Guardar"><i class="fa fa-save"></i> Guardar</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Lugar de Producción {{codigo}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <!--***ICONOS***-->
                <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <label class="codigo2-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{codigoTipoSolicitud}}</label>-->
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudCpe | IconoEstadoSolicitudCpe}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <!--PARCELAS-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedParcelas = !isCollapsedParcelas" [attr.aria-expanded]="!isCollapsedParcelas" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Parcelas
                                    <i *ngIf="isCollapsedParcelas" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedParcelas" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">
                                <div class="collapse group-filtros" id="collapsed" [ngbCollapse]="isCollapsedParcelas">

                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="intProvincia">Provincia</label>
                                            <ng-select loadingText="Cargando..."
                                                       [items]="listProvinciaParcela"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvinciaParcela"
                                                       [loading]="!listProvinciaParcela"
                                                       notFoundText="Provincia no encontrada"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelectNoSubmit('IdProvinciaParcela')"
                                                       (change)="onSelectProvinciaParcela()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('IdProvinciaParcela','required')">
                                                Provincia es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label required-field" for="">Municipio</label>
                                            <ng-select loadingText="Cargando..."
                                                       [items]="listMunicipioParcela"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdMunicipioParcela"
                                                       [loading]="!listMunicipioParcela && (form.value.IdProvinciaParcela > 0)"
                                                       notFoundText="Municipio no encontrado"
                                                       placeholder="-- Seleccione un Municipio --"
                                                       clearAllText="Eliminar selección"
                                                       [ngClass]="displayFieldCssNgSelectNoSubmit('IdMunicipioParcela')"
                                                       (change)="onSelectMunicipioParcela()">
                                            </ng-select>

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('IdMunicipioParcela','required')">
                                                Municipio es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="inp">Dirección</label>
                                            <input formControlName="DireccionParcela" maxlength="250" name="DireccionParcela" title="" class="form-control" id="inpDescripcion" type="text" value="">
                                        </div>
                                    </div>

                                    <div class="row">

                                        <!--<div class="form-group col-md-6">
                                            <label class="col-form-label" for="">Código SigPac</label>
                                            <div class="input-group">
                                                <input formControlName="CodigoSigPac" numbersOnly name="CodigoSigPac" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="50">

                                                <span class="input-group-btn">
                                                    &nbsp;<button [disabled]="!habilitarGuardar" name="btnVerSigpac" class="btn btn-list btn-secondary" type="button" title="Ver en SIGPAC" (click)="onShowSigpac()"><i class="fa fa-location-arrow"></i></button>
                                                </span>
                                            </div>
                                        </div>-->

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Municipio SIGPAC</label>
                                            <input formControlName="MunicipioSigpac" readonly numbersOnly name="MunicipioSigpac" title="" [ngClass]="displayFieldCssNoSubmit('MunicipioSigpac')" class="form-control" id="inp" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('MunicipioSigpac','required')">
                                                Municipio SIGPAC es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Agregado</label>
                                            <input formControlName="Agregado" numbersOnly name="Agregado" title="" [ngClass]="displayFieldCssNoSubmit('Agregado')" class="form-control" id="inp" type="text" value="" maxlength="3">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Agregado','required')">
                                                Agregado es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Zona</label>
                                            <input formControlName="Zona" numbersOnly name="Zona" title="" [ngClass]="displayFieldCssNoSubmit('Zona')" class="form-control" id="inp" type="text" value="" maxlength="2">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Zona','required')">
                                                Zona es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Polígono</label>
                                            <input formControlName="Poligono" numbersOnly name="Poligono" title="" [ngClass]="displayFieldCssNoSubmit('Poligono')" class="form-control" id="inp" type="text" value="" maxlength="3">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Poligono','required')">
                                                Polígono es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Parcela</label>
                                            <input formControlName="Parcela" numbersOnly name="Parcela" title="" [ngClass]="displayFieldCssNoSubmit('Parcela')" class="form-control" id="inp" type="text" value="" maxlength="5">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Parcela','required')">
                                                Parcela es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-2">
                                            <label class="col-form-label required-field" for="inp">Recinto</label>
                                            <input formControlName="Recinto" numbersOnly name="Recinto" title="" [ngClass]="displayFieldCssNoSubmit('Recinto')" class="form-control" id="inp" type="text" value="" maxlength="5">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('Recinto','required')">
                                                Recinto es obligatorio
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row">

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="inp">Superficie SIGPAC (ha)</label>
                                            <input formControlName="SuperficieSigPac" readonly [decimalsOnly]="2" maxlength="15" [ngClass]="displayFieldCssNoSubmit('SuperficieSigPac')" name="SuperficieSigPac" title="" class="form-control" id="inp" type="text" value="">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('SuperficieSigPac','required')">
                                                Superficie SIGPAC es obligatoria
                                            </div>
                                        </div>

                                        <div class="form-group col-md-3">
                                            <label class="col-form-label required-field" for="">Uso SIGPAC</label>
                                            <input formControlName="UsoSigPac" readonly name="UsoSigPac" title="" class="form-control" [ngClass]="displayFieldCssNoSubmit('UsoSigPac')" id="inpNombre" type="text" value="" maxlength="10">

                                            <div class="invalid-feedback d-block" *ngIf="isFieldInvalidNoSubmit('UsoSigPac','required')">
                                                Uso SIGPAC es obligatorio
                                            </div>
                                        </div>

                                        <div class="form-group col-md-6">
                                            <div style="float:left">
                                                <label class="col-form-label" for="">Acciones</label>
                                                <div class="input-group input-group-btn">

                                                    <span class="input-group-btn">
                                                        <button [disabled]="!habilitarGuardar" name="btnValidar" class="btn btn-list btn-secondary" type="button" title="Validar en SIGPAC" (click)="onValidarSigpac()"><i class="fa fa-check"></i> Validar en SIGPAC</button>
                                                    </span>
                                                    <span class="input-group-btn">
                                                        &nbsp;<button [disabled]="!habilitarGuardar" name="btnVerSigpac" class="btn btn-list btn-secondary" type="button" title="Ver en SIGPAC" (click)="onShowSigpac()"><i class="fa fa-search"></i> Ver en SIGPAC</button>
                                                    </span>
                                                    <span class="input-group-btn">
                                                        &nbsp;<button [disabled]="!habilitarGuardar" name="btnAddParcela" class="btn btn-list btn-secondary" type="button" title="Añade una Parcela" (click)="onAddParcela()"><i class="fa fa-plus"></i> Añadir</button>
                                                    </span>
                                                    <span class="input-group-btn">
                                                        &nbsp;<button [disabled]="!habilitarGuardar" name="btnReset" class="btn btn-list btn-secondary" type="button" title="Limpiar campos" (click)="onResetParcela()"><i class="fa fa-undo"></i> Limpiar</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!--GRID-->
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="card card-accent-success animated fadeIn" style="margin-top: 1rem !important; margin-bottom: 0.2rem !important;">
                                                <a class="card-header-a">
                                                    <div class="card-header-buscador">
                                                        <i class="fa fa-list"></i> Listado de Parcelas
                                                    </div>
                                                </a>

                                                <div class="card-body-grid">

                                                    <p-table #tableSearch autoLayout="true" [value]="solicitudCpeLugarProduccion.TwParcelasCertificadoPrevioExCollection"
                                                             [columns]="colsParcelas" sortField="CodigoSigPac" sortOrder="-1"
                                                             styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                                             [ngClass]="displayGridHidden(solicitudCpeLugarProduccion.TwParcelasCertificadoPrevioExCollection)">

                                                        <ng-template pTemplate="header" let-columns>
                                                            <tr>
                                                                <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                                    {{col.header}}
                                                                    <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                                                </th>
                                                            </tr>
                                                        </ng-template>
                                                        <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                                            <tr>

                                                                <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                                    <span *ngIf="(col.field!=='Link' && col.field!=='SuperficieSigPac')">
                                                                        {{rowData[col.field]}}
                                                                    </span>

                                                                    <span *ngIf="(col.field==='SuperficieSigPac')">
                                                                        {{rowData[col.field] | number:'1.2-2':'es'}}
                                                                    </span>

                                                                    <div *ngIf="col.field==='Link'" class="btn-group">
                                                                        <button (click)="onDeleteParcela(rowData)" [disabled]="!habilitarGuardar" type="button" title="Eliminar"
                                                                                class="btn btn-sm btn-danger">
                                                                            <span class="fa fa-remove"></span>
                                                                        </button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </ng-template>
                                                    </p-table>
                                                    <div *ngIf="numeroParcelas === 0" class="empty-grid">
                                                        No hay parcelas asociadas a la solicitud
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!--LUGAR PRODUCCION-->
                <div class="row">
                    <div class="col-md-12">

                        <div class="card card-accent-success animated fadeIn">
                            <a class="card-header-a" (click)="isCollapsedOtroLugar = !isCollapsedOtroLugar" [attr.aria-expanded]="!isCollapsedOtroLugar" aria-controls="collapseExample">
                                <div class="card-header-buscador">
                                    <i class="fa fa-file-text-o"></i> Lugar de Producción
                                    <i *ngIf="isCollapsedOtroLugar" class="fa fa-caret-down float-right"></i>
                                    <i *ngIf="!isCollapsedOtroLugar" class="fa fa-caret-up float-right"></i>
                                </div>
                            </a>
                            <div class="card-body-detalle">

                                <div class="collapse group-filtros" id="isCollapsedOtroLugar" [ngbCollapse]="isCollapsedOtroLugar">
                                    <div class="row">

                                        <div class="form-group col-md-4">
                                            <label class="col-form-label" for="intProvincia">Provincia</label>
                                            <ng-select loadingText="Cargando..."
                                                       [items]="listProvinciaLugar"
                                                       bindLabel="Descripcion"
                                                       bindValue="Id"
                                                       formControlName="IdProvinciaLugar"
                                                       [loading]="!listProvinciaLugar"
                                                       notFoundText="Provincia no encontrada"
                                                       placeholder="-- Seleccione una Provincia --"
                                                       clearAllText="Eliminar selección">
                                            </ng-select>
                                        </div>

                                        <div class="form-group col-md-8">
                                            <label class="col-form-label" for="">Lugar Producción</label>
                                            <input formControlName="LugarProduccion" name="LugarProduccion" title="" class="form-control" id="inpNombre" type="text" value="" maxlength="250">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
